/*
  This file contain entire application's URL
*/

// Trial
import { GENERAL_URLS } from "@Vytelle/admin/src/constants/MenuURLS/GeneralManagement";
import { LOCATION_URLS } from "@Vytelle/admin/src/constants/MenuURLS/locationManagement";
import { COMPANY_URLS } from "@Vytelle/admin/src/constants/MenuURLS/CompanyManagement";
import { USER_URLS } from "@Vytelle/admin/src/constants/MenuURLS/UserManagement";
import { RELEASE_NOTES_URLS } from "@Vytelle/admin/src/constants/MenuURLS/ReleaseNotesManagement";

const URL = {
  LOGIN: "/login", // Login
  RESET_PASSWORD: "/reset-password", // Reset Password
  FORGOT_PASSWORD: "/forgot-password", // Forgot Password
  FORGOT_PASSWORD_SUCCESS: "/forgot-password-success",
  SETTINGS: "/settings", // Settings

  ERROR: {
    PAGE404: "/page404",
    PAGE500: "/page500",
  },

  ...GENERAL_URLS,

  /* User URLS*/
  ...USER_URLS,

  /* Location URLS*/
  ...LOCATION_URLS,

  /* Company URLS */
  ...COMPANY_URLS,

  /* Release Notes URLS */
  ...RELEASE_NOTES_URLS,
};

export default URL;
